function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import styled, { css } from "styled-components";
import IconLoader from "../icons/IconLoader";
import { keyframes } from "styled-components";

var rotate = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);

var Loader = function Loader(_ref) {
  var pulse = _ref.pulse,
      props = _objectWithoutProperties(_ref, ["pulse"]);

  return React.createElement(IconLoader, props);
};

export default styled(Loader).withConfig({
  displayName: "Loader",
  componentId: "zkgnai-0"
})(["animation:", ";"], function (props) {
  return props.pulse ? css(["1s steps(8) infinite ", ""], rotate) : css(["1.5s linear infinite ", ""], rotate);
});